import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpUtils } from '../utils/httpUtils';
import { ExecutionQTestCriticalInstrumentation } from '../model/execution';

@Injectable({
  providedIn: 'root'
})
export class ExecutionQTestCriticalInstrumentationService {

  readonly baseUrl = `${environment.qualificatesUrl}/executionQTestCriticalInstrumental`;
  constructor(private http: HttpClient) { }

  updateCritical(idExecution: number, idExecutionTest: number, data: ExecutionQTestCriticalInstrumentation): Observable<any> {
    const url = `${this.baseUrl}/${idExecutionTest}`;
    return this.http.put(url, data).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
  }
}
